import { render } from "./News11.vue?vue&type=template&id=26d6f3a2&scoped=true"
import script from "./News11.vue?vue&type=script&lang=js"
export * from "./News11.vue?vue&type=script&lang=js"

import "./News11.vue?vue&type=style&index=0&id=26d6f3a2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26d6f3a2"]])

export default __exports__